import script from "./RightMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RightMenu.vue?vue&type=script&setup=true&lang=js"

import "./RightMenu.vue?vue&type=style&index=0&id=166d5160&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-166d5160"]])

export default __exports__